import { unifiedColors } from 'styles/colors'
import { styled } from 'styles/styled'
import { themeUtils } from 'styles/theme'

export const MainContainerIncluded = styled.div`
  border-radius: 20px;
  padding: 34px 32px;
  background-color: ${unifiedColors.surface.subdued};

  ${themeUtils.maxWidth.sm} {
    padding: 17px 15px;
  }
`
export const BodyContainerIncluded = styled.div`
  border-radius: 20px;
`

export const CheckContainer = styled.div`
  background-color: ${unifiedColors.surface.green};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  margin-right: 8px;
`
export const ServiceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 16px;
  margin-top: 19px;
`

interface ServiceItemProps {
  $index: number
}

export const ServiceItem = styled.div<ServiceItemProps>`
  width: 50%;
  align-self: ${({ $index }) => ($index % 2 === 0 ? 'flex-start' : 'flex-end')};
  display: flex;
  align-items: center;
  ${themeUtils.maxWidth.sm} {
    width: 100%;
  }
`
